/**
 * Barramento dos arrastos remotos.
 *
 * As posições chegam a ~15 Hz por jogador. Mantê-las fora do estado do React
 * evita dezenas de renderizações por segundo: o componente lê as posições
 * dentro de um `requestAnimationFrame` e interpola suavemente. Somente a
 * entrada/saída de um arrasto (evento raro) notifica os assinantes.
 */
export type DragTarget = { x: number; y: number; updatedAt: number };

const targets = new Map<string, DragTarget>();
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) listener();
}

export const dragBus = {
  start(playerId: string, x: number, y: number): void {
    const existed = targets.has(playerId);
    targets.set(playerId, { x, y, updatedAt: Date.now() });
    if (!existed) notify();
  },

  move(playerId: string, x: number, y: number): void {
    const existed = targets.has(playerId);
    targets.set(playerId, { x, y, updatedAt: Date.now() });
    if (!existed) notify();
  },

  end(playerId: string): void {
    if (targets.delete(playerId)) notify();
  },

  clear(): void {
    if (targets.size === 0) return;
    targets.clear();
    notify();
  },

  get(playerId: string): DragTarget | undefined {
    return targets.get(playerId);
  },

  activePlayers(): string[] {
    return [...targets.keys()];
  },

  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
